export const extractProductDiscountsFromBooking = (booking) => {
    if (!booking.offer) {
        return {};
    }

    return Object.fromEntries(
        booking.offer.products
            .filter((op) => booking.products.some((p) => p.id === op.product.id))
            .map((op) => [op.product.id, Number(Number(op.discount_percent).toFixed(2))]),
    );
};
